var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center"},[_c('v-snackbar',{attrs:{"color":_vm.$store.getters.alertColor,"to":true,"top":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v("\n    "+_vm._s(_vm.$store.getters.alertMessage)+"\n    "),_c('v-btn',{attrs:{"dark":"","text":""},on:{"click":function($event){return _vm.$store.dispatch('SetAlert', {
          showAlert: false,
          message: '',
          color: ''
        })}}},[_vm._v("\n      Close\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68942684","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/components/snackBar.vue
// module id = null
// module chunks = 